import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon, SettingsIcon } from 'lucide-react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
const FCH_LOGO_WHITE = 'https://cdn.magicpatterns.com/uploads/wAdPA7wgvdq7XrQn29qvhh/FCh_logo_White.svg';
const links = [{
  href: '/#o-akci',
  label: 'O akci',
  isHash: true
}, {
  href: '/#pravidla',
  label: 'Pravidla',
  isHash: true
}, {
  href: '/#termin',
  label: 'Termín',
  isHash: true
}, {
  href: '/#cena',
  label: 'Cena',
  isHash: true
}, {
  href: '/galerie',
  label: 'Galerie',
  isHash: false
}, {
  href: '/#kontakt',
  label: 'Kontakt',
  isHash: true
}];
export function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  // Handle scrolling to hash when location changes
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }, 100);
    } else if (location.pathname === '/') {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }, [location]);
  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>, link: (typeof links)[0]) => {
    setMobileOpen(false);
    if (link.isHash) {
      const hash = link.href.replace('/', '');
      if (location.pathname === '/') {
        e.preventDefault();
        // We are already on home page, just scroll
        const el = document.querySelector(hash);
        if (el) {
          el.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
        // Update URL without full reload
        window.history.pushState(null, '', hash);
      }
      // If not on home page, let the default Link behavior navigate to /#hash
    }
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled || location.pathname !== '/' ? 'bg-navy-deep/95 backdrop-blur-md shadow-lg' : 'bg-transparent'}`} data-id="element-146">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-147">
        <div className={`flex items-center justify-between transition-all duration-500 ${scrolled || location.pathname !== '/' ? 'h-16' : 'h-20'}`} data-id="element-148">
          {/* Logo + wordmark */}
          <Link to="/" className={`flex items-center gap-3 group transition-all duration-500 ${scrolled || location.pathname !== '/' ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-2 pointer-events-none'}`} aria-label="Future Challenge - na začátek stránky" aria-hidden={!(scrolled || location.pathname !== '/')} tabIndex={scrolled || location.pathname !== '/' ? 0 : -1} data-id="element-149">
            <img src="https://cdn.magicpatterns.com/uploads/6ikzqbMg3YKiQTBTLZDAFn/FutureChallenge.svg" alt="Future Challenge" className="hidden sm:block h-4 md:h-5 w-auto" style={{
            filter: 'brightness(0) invert(1)'
          }} data-id="element-150" />
          </Link>

          {/* Desktop nav */}
          <nav className="hidden md:flex items-center gap-1" data-id="element-151">
            {links.map(link => <Link key={link.href} to={link.href} onClick={e => handleLinkClick(e, link)} className="relative px-4 py-2 text-sm font-medium text-white/90 hover:text-white transition-colors duration-200 group" data-id="element-152">
                {link.label}
                <span className="absolute bottom-1 left-4 right-4 h-px bg-white scale-x-0 group-hover:scale-x-100 origin-left transition-transform duration-300" data-id="element-153" />
              </Link>)}
            <Link to="/nastaveni" className="ml-2 p-2 text-white/70 hover:text-white transition-colors" aria-label="Nastavení" data-id="element-154">
              <SettingsIcon className="w-5 h-5" data-id="element-155" />
            </Link>
          </nav>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center gap-2" data-id="element-156">
            <Link to="/nastaveni" className="p-2 text-white/90" aria-label="Nastavení" data-id="element-157">
              <SettingsIcon className="w-5 h-5" data-id="element-158" />
            </Link>
            <button type="button" onClick={() => setMobileOpen(!mobileOpen)} className="p-2 text-white" aria-label={mobileOpen ? 'Zavřít menu' : 'Otevřít menu'} aria-expanded={mobileOpen} data-id="element-159">
              {mobileOpen ? <XIcon className="w-6 h-6" data-id="element-160" /> : <MenuIcon className="w-6 h-6" data-id="element-161" />}
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        <div className={`md:hidden overflow-hidden transition-all duration-300 ${mobileOpen ? 'max-h-96 pb-6' : 'max-h-0'}`} data-id="element-162">
          <nav className="flex flex-col gap-1 pt-2" data-id="element-163">
            {links.map(link => <Link key={link.href} to={link.href} onClick={e => handleLinkClick(e, link)} className="px-4 py-3 text-white/90 hover:text-white hover:bg-white/10 rounded-lg transition-colors duration-200 font-medium" data-id="element-164">
                {link.label}
              </Link>)}
          </nav>
        </div>
      </div>
    </header>;
}